import Axios from 'axios';

const axiosConfig = {
  headers: {
    common: {},
  },
  baseURL: process.env.VUE_APP_API_BASE_URL,
};
const staticAxiosConfig = {
  baseURL: process.env.VUE_APP_STATIC_URL,
};
const eventSystemAxiosConfig = {
  baseURL: process.env.VUE_APP_EVENT_SYSTEM_BASE_URL,
};
const axios = Axios.create(axiosConfig);
const staticAxios = Axios.create(staticAxiosConfig);
const eventSystemAxios = Axios.create(eventSystemAxiosConfig);

const useAxios = () => axios;
const useStaticAxios = () => staticAxios;
const useEventSystemAxios = () => eventSystemAxios;

export { useAxios, useStaticAxios, useEventSystemAxios };
